import {
  FETCH_VSDC_FAILED_REQUESTS_ATTEMPT,
  FETCH_VSDC_FAILED_REQUESTS_SUCCESS,
  FETCH_VSDC_FAILED_REQUESTS_ERROR,
  CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT,
  CLEAR_VSDC_FAILED_REQUESTS_SUCCESS,
  CLEAR_VSDC_FAILED_REQUESTS_ERROR,
  CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE,
  FETCH_TEST_DEVICES_ATTEMPT,
  FETCH_TEST_DEVICES_SUCCESS,
  FETCH_TEST_DEVICES_ERROR,
  SUBMIT_TEST_INVOICE_ATTEMPT,
  SUBMIT_TEST_INVOICE_SUCCESS,
  SUBMIT_TEST_INVOICE_ERROR,
  SUBMIT_TEST_INVOICE_RESET_STATE,
} from "../actionTypes/actionTypes";

const initialState = {
  failedRequests: {
    data: {
      requests: [],
      total: 0,
    },
    attempt: false,
    success: false,
    error: null,
  },
  clearRequests: {
    attempt: false,
    success: false,
    error: null,
    data: null,
  },
  testDevices: {
    data: {
      devices: [],
      total: 0,
    },
    attempt: false,
    success: false,
    error: null,
  },
  submitInvoice: {
    attempt: false,
    success: false,
    error: null,
    data: null,
  },
};

const vsdcFailedRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VSDC_FAILED_REQUESTS_ATTEMPT:
      return {
        ...state,
        failedRequests: {
          ...state.failedRequests,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_VSDC_FAILED_REQUESTS_SUCCESS:
      return {
        ...state,
        failedRequests: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_VSDC_FAILED_REQUESTS_ERROR:
      return {
        ...state,
        failedRequests: {
          ...state.failedRequests,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case CLEAR_VSDC_FAILED_REQUESTS_ATTEMPT:
      return {
        ...state,
        clearRequests: {
          attempt: true,
          success: false,
          error: null,
          data: null,
        },
      };
    case CLEAR_VSDC_FAILED_REQUESTS_SUCCESS:
      return {
        ...state,
        clearRequests: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload,
        },
        failedRequests: {
          ...state.failedRequests,
          data: {
            requests: [],
            total: 0,
          },
        },
      };
    case CLEAR_VSDC_FAILED_REQUESTS_ERROR:
      return {
        ...state,
        clearRequests: {
          attempt: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case CLEAR_VSDC_FAILED_REQUESTS_RESET_STATE:
      return {
        ...state,
        clearRequests: {
          attempt: false,
          success: false,
          error: null,
          data: null,
        },
      };
    case FETCH_TEST_DEVICES_ATTEMPT:
      return {
        ...state,
        testDevices: {
          ...state.testDevices,
          attempt: true,
          success: false,
          error: null,
        },
      };
    case FETCH_TEST_DEVICES_SUCCESS:
      return {
        ...state,
        testDevices: {
          data: action.payload,
          attempt: false,
          success: true,
          error: null,
        },
      };
    case FETCH_TEST_DEVICES_ERROR:
      return {
        ...state,
        testDevices: {
          ...state.testDevices,
          attempt: false,
          success: false,
          error: action.payload,
        },
      };
    case SUBMIT_TEST_INVOICE_ATTEMPT:
      return {
        ...state,
        submitInvoice: {
          attempt: true,
          success: false,
          error: null,
          data: null,
        },
      };
    case SUBMIT_TEST_INVOICE_SUCCESS:
      return {
        ...state,
        submitInvoice: {
          attempt: false,
          success: true,
          error: null,
          data: action.payload,
        },
      };
    case SUBMIT_TEST_INVOICE_ERROR:
      return {
        ...state,
        submitInvoice: {
          attempt: false,
          success: false,
          error: action.payload,
          data: null,
        },
      };
    case SUBMIT_TEST_INVOICE_RESET_STATE:
      return {
        ...state,
        submitInvoice: {
          attempt: false,
          success: false,
          error: null,
          data: null,
        },
      };
    default:
      return state;
  }
};

export default vsdcFailedRequestsReducer;

